import { BrokerExtensions, brokerExtensions } from "@primaria/plugins-core";
import { PrimariaApi } from "@uxland/primary-shell";
import { container } from "../infrastructure/ioc/container";
import { bootstrapInjectAsyncHistoryItems, teardownInjectAsyncHistoryItems } from "./add/add-async-history-items/bootstrapper";
import { bootstrapAddHistoryItem, teardownAddHistoryItem } from "./add/add-history-item/bootstrapper";
import { bootstrapAddHistoryItems, teardownAddHistoryItems } from "./add/add-history-items/bootstrapper";
import { bootstrapActivityHistoryItemHandleBusy } from "./add/handle-busy/bootstrapper";
import {
  bootstrapHandleHistoryItemsAddError,
  teardownHandleHistoryItemsAddError,
} from "./add/handle-error/handle-history-items-add-error/bootstrapper";
import { bootstrapExportPdf, teardownExportPdf } from "./export-to-pdf/bootstrapper";
import { bootstrapFilters, teardownFilters } from "./filter/bootstrapper";
import { bootstrapListActivityHistoryItems } from "./list/bootstrapper";
import { bootstrapHandleRefreshHistoryItems } from "./refresh/bootstrapper";
import { bootstrapRemoveHistoryItem, teardownRemoveHistoryItem } from "./remove/bootstrapper";
import { bootstrapSearchItems, teardownSearchItems } from "./search/bootstrapper";
import { bootstrapUpdateHistoryItem, teardownUpdateHistoryItem } from "./update/bootstrapper";

let broker: BrokerExtensions;

export const bootstrapActivityHistoryItem = (api: PrimariaApi) => {
  broker = brokerExtensions(api, container);
  bootstrapListActivityHistoryItems();
  bootstrapActivityHistoryItemHandleBusy();
  bootstrapInjectAsyncHistoryItems(broker, api);
  bootstrapAddHistoryItem(broker, api);
  bootstrapAddHistoryItems(broker, api);
  bootstrapHandleHistoryItemsAddError(broker);
  bootstrapHandleRefreshHistoryItems(broker);
  bootstrapUpdateHistoryItem(broker);
  bootstrapExportPdf(broker);
  bootstrapFilters(broker, api);
  bootstrapSearchItems(broker);
  bootstrapRemoveHistoryItem(broker);
};

export const teardownActivityHistoryItem = () => {
  teardownInjectAsyncHistoryItems();
  teardownAddHistoryItem();
  teardownAddHistoryItems();
  teardownHandleHistoryItemsAddError();
  teardownUpdateHistoryItem();
  teardownExportPdf();
  teardownFilters();
  teardownSearchItems();
  teardownRemoveHistoryItem();
};
